import * as TypeGraphQL from "type-graphql";
export var NullsOrder;
(function (NullsOrder) {
    NullsOrder["first"] = "first";
    NullsOrder["last"] = "last";
})(NullsOrder || (NullsOrder = {}));
TypeGraphQL.registerEnumType(NullsOrder, {
    name: "NullsOrder",
    description: undefined,
});
//# sourceMappingURL=NullsOrder.js.map